export const STORE_SELLER_VIEW_ROLES = [
  'ROLE_ADMIN',
  'ROLE_BRAND_ADMIN',
  'ROLE_SUPER_ADMIN',
  'ROLE_STORE_MANAGER',
  'ROLE_SUPER_STORE',
];

export const STORE_TRADE_IN_FORM_ROLES = [
  'ROLE_SUPER_STORE',
  'ROLE_STORE_SELLER',
  'ROLE_STORE_MANAGER',
];

export function canAccessStoreTradeInForm(user) {
  const roles = user?.roles || [];
  return STORE_TRADE_IN_FORM_ROLES.some((role) => roles.includes(role));
}

export function sellerIdFromRoute(route) {
  return route.params.sellerId || route.params.id;
}

export function clientIdFromRoute(route) {
  return route.params.id;
}

export function storeManagerClientId(user) {
  return user?.clients?.[0]?.id;
}

export function clientStoresRoute(clientId) {
  return {
    name: 'client-stores',
    params: { id: String(clientId) },
  };
}

export function storeSellerListRoute(clientId) {
  return {
    name: 'client-store-sellers',
    params: { id: String(clientId) },
  };
}

export function storeSellerCreateRoute(clientId) {
  return {
    name: 'client-store-seller-create',
    params: { id: String(clientId) },
  };
}

export function storeSellerEditRoute(clientId, sellerId) {
  return {
    name: 'client-store-seller-edit',
    params: { id: String(clientId), sellerId: String(sellerId) },
  };
}

export function storeSellerDeleteRoute(clientId, sellerId) {
  return {
    name: 'client-store-seller-delete',
    params: { id: String(clientId), sellerId: String(sellerId) },
  };
}
